import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';
import { Typography } from '~/shared/ui/Typography/Typography';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const Line = styled.div`
  flex: 1;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
`;

export const RightLine = styled.div`
  flex: 1;
  height: 1px;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 0) 100%
  );
`;

export const Text = styled(Typography.H5)`
  color: ${uiToken.color.text.secondary};
`;
